export default __webpack_public_path__ + "static/media/unsubscribe_2.6e00d622.png";